import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { forwardRef, memo } from "react";
export const TreeItemButton = /*#__PURE__*/ memo(/*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { className, children, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("button", {
        "data-testid": "TREE_ITEM_BUTTON",
        className: tailwindMerge('border-box flex h-full w-full min-w-0 items-center justify-start text-14 after:absolute after:inset-0 after:-z-1 after:h-full after:w-full after:content-[""] disabled:cursor-not-allowed disabled:opacity-45', className),
        ref: forwardedRef,
        type: "button",
        ...restOfProps,
        children: /*#__PURE__*/ _jsx("span", {
            className: "truncate",
            children: children
        })
    });
}));
TreeItemButton.displayName = "TreeItemButton";
